{
  "header": "Framework",
  "searchLabel": "Søk etter skogeier",
  "searchButton": "Søk",
  "tableReadyOverlayDescription": "Søk etter en skogeier for å se resultater.",
  "tableEmptyOverlayMessage": "Ingen skogeiere funnet.",
  "tableLoaderOverlayMessage": "Søker etter skogeiere...",
  "tableErrorOverlayMessage": "Kunne ikke søke etter skogeiere. Prøv igjen.",
  "columns": {
    "name": "Navn",
    "representative": "Representant",
    "postalPlace": "Poststed",
    "type": "Type"
  }
}
